import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EmployeeInfoService } from './employee-info.service';
import { EventService } from './event.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TimeoutModalComponent } from '../../modals/shared/timeout-modal/timeout-modal.component';

@Injectable({
  providedIn: 'root',
})
export class TimeoutService {
  //How frequently to check for session expiration in milliseconds
  private sess_pollInterval = 10000;
  //Minutes the session is valid
  private sess_expiration: number;
  //Minutes before the warning
  private sess_warning: number;
  private sess_lastActivity: Date;
  private sess_intervalID: any;
  private timeoutModalOpen: boolean;
  private sess_timedout: boolean;
  private isSaving: boolean;
  private refreshingTimeout: boolean;
  private http: HttpClient;
  private employeeInfo: any;

  constructor(
    http: HttpClient,
    employeeInfoService: EmployeeInfoService,
    private eventService: EventService,
    private ngbModalService: NgbModal
  ) {
    this.http = http;
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
  }

  initializeTimeoutConfig() {
    this.http.get('/Admin/GetTimeoutLength').subscribe(response => {
      const timeoutConfig = response;
      this.initTimeout(timeoutConfig);
    });
  }

  initTimeout(timeoutConfig: any) {
    this.sess_expiration = timeoutConfig;
    this.sess_warning = timeoutConfig - 1;
    this.initializeTimeout();
  }

  sessionTimedOut() {
    return this.sess_timedout;
  }

  private initializeTimeout() {
    this.sess_lastActivity = new Date();
    this.setTimeoutInterval();
  }

  private setTimeoutInterval() {
    this.sess_intervalID = setInterval(this.timeoutInterval, this.sess_pollInterval);
  }

  private clearTimeoutInterval() {
    clearInterval(this.sess_intervalID);
  }

  refreshSession() {
    this.refreshSessionInternal();
  }

  private refreshSessionInternal() {
    this.http.post('/Account/Refresh', null, { responseType: 'text' }).subscribe((response: any) => {
      this.timeoutModalOpen = false;
      this.refreshTimeoutInternal();
    });
  }

  refreshTimeout() {
    this.sess_timedout = false;
    this.refreshTimeoutInternal();
  }

  private refreshTimeoutInternal() {
    this.refreshingTimeout = true;
    this.clearTimeoutInterval();

    this.http.get('/Admin/GetTimeoutLength').subscribe(response => {
      const timeoutConfig = Number(response.toString());
      this.sess_expiration = timeoutConfig;
      this.sess_warning = timeoutConfig - 1;
      this.initializeTimeout();
      this.refreshingTimeout = false;
    });
  }

  getLastActivityTime() {
    const now = new Date();
    const diff = now.valueOf() - this.sess_lastActivity.valueOf();
    return diff / 1000 / 60;
  }

  getTimeoutConfig() {
    return this.sess_expiration;
  }

  getRefreshingTimeout() {
    return this.refreshingTimeout;
  }

  private timeoutInterval = () => {
    const now = new Date();
    const diff = now.valueOf() - this.sess_lastActivity.valueOf();
    const diffMins = diff / 1000 / 60;

    if (diffMins >= this.sess_warning) {
      this.sess_timedout = true;
      if (!this.isSaving) {
        this.eventService.broadcast('saveTimecard');
        this.isSaving = true;
      }
      if (!this.timeoutModalOpen) {
        this.timeoutModalOpen = true;
        const modalRef = this.ngbModalService.open(TimeoutModalComponent, { size: 'sm', backdrop: 'static', keyboard: false });

        modalRef.result.then(result => {
          if (result == 'refresh') {
            this.refreshSession();
          } else if (result == 'logout') {
            this.clearTimeoutInterval();
            this.timeoutModalOpen = false;
            window.location.href = '/Account/Logout';
          }
        });
      }

      if (diffMins >= this.sess_expiration) {
        if (this.employeeInfo == null && document.referrer != null) {
          if (document.referrer.toLowerCase().indexOf('jobdetails') > -1)
            window.location.href = '/Account/Logout?timedOut=true&applicant=true';
          else window.location.href = '/Account/Logout?timedOut=true&onboard=true';
        } else window.location.href = '/Account/Logout?timedOut=true';
      }
    }
  };
}
